import React, { useState } from 'react';
import MetamaskLogo from '../assets/icons/MetaMask_Fox.png';
import { useAccount, useConnect } from 'wagmi';
import { web3AuthModal } from '..';
import Loading from './Loading';
const MetamaskLogin = () => {
	const [loading, setLoading] = useState(false);
	const handleMatamaskAuth = web3AuthModal.handleAuthMetamask;
	return (
		<>
			{loading ? <Loading /> : null}
			<div
				className='web3Auth_walletLogin'
				onClick={() => handleMatamaskAuth()}>
				<div className='web3Auth_logoBox'>
					<img
						src={MetamaskLogo}
						alt='metamask logo'
						className='web3Auth_walletLogin_img'
					/>
					<p className='web3Auth_metamsk_text'>
						Continue with Crypto Wallet
					</p>
				</div>
			</div>
		</>
	);
};
export default MetamaskLogin;
